@if (error) {
  <rpt-element-error [error]="error" />
} @else {
  @switch (type) {
    @case (FundsportraitBlueprintType.Header) {
      <wct-fondsportrait-header
        [documentId]="documentId"
        [reportIndex]="reportIndex" />
    }

    @case (FundsportraitBlueprintType.Generic) {
      <wct-document-host
        [documentId]="documentId"
        [reportIndex]="reportIndex"
        [autofill]="true"
        [funds]="selectedFund.get()"
        [autofillOptions]="elementOptions" />
    }

    @case (FundsportraitBlueprintType.ValueDevelopmentTable) {
      <wct-value-development-table
        [documentId]="documentId"
        [reportIndex]="reportIndex" />
    }

    @case (FundsportraitBlueprintType.ValueDevelopment) {
      <div
        class="document-host"
        provideElements
        [documentId]="documentId"
        [reportIndex]="reportIndex"
        [funds]="selectedFund.get()">

        <wct-element-host [element]="'Header' | element | async" />

        <wct-element-host
          [element]="('Wertentwicklung' | element | async) ?? ('Wertentwicklung_BMK' | element | async)"
          [options]="{
            valueDevelopmentVisualization: true,
            chartSizeStrategy: HighchartsSizeStrategy.FIT_CONTAINER_HEIGHT
          }" />

        <wct-element-host [element]="'Fussnote' | element | async" />
      </div>
    }

    @case (FundsportraitBlueprintType.WorldMap) {
      <wct-country-chart [documentId]="documentId" [reportIndex]="reportIndex" />
    }

    @default {
      Unimplemented type: {{ type }}
    }
  }
}
